<template>
  <div class="account-tab-item__group-item"
  >
    <div class="account-tab-item__group-item-row _mod">
      <div class="account-tab-item__group-item-col">
        <div class="account-tab-item__label-mob">{{ $tAccount('Request') }}</div>
        <div class="account-tab-item__date">
          {{ item.created_at | formatDate }}
        </div>
      </div>
      <div class="account-tab-item__group-item-col">
        <div class="account-tab-item__label-mob">{{ $tAccount('Status') }}</div>
        <div class="status _grey" v-if="item.status === STATUS_RECEIVED_TO_WORK">
          {{ $tAccount('Accepted for work') }}
        </div>
        <div class="status _orange" v-if="item.status === STATUS_IN_PROCESS">
          {{ $tAccount('Processed') }}
        </div>
        <div class="status _green" v-if="item.status === STATUS_PAID_OUT">
          {{ $tAccount('Paid out') }}
        </div>
      </div>
      <div class="account-tab-item__group-item-col">
        <div class="account-tab-item__label-mob">{{ $tAccount('Payout') }}</div>
        <div class="account-tab-item__date">
          {{ item.end_date | formatDate }}
        </div>
      </div>
    </div>
    <div class="account-tab-item__group-item-row">
      <div v-if="item.withdraw_method"
           class="account-tab-item__operation-mob">
        <template v-if="true">
          <BaseSvg :name="item.withdraw_method.icon"
                   class="account-tab-item__operation-mob-ico"/>
          <span>{{ item.withdraw_method.name }}</span>
        </template>
      </div>
    </div>
    <div class="account-tab-item__group-item-row">
      <div class="account-tab-item__repeat-mob">
        <button type="button" class="account-tab-item__repeat base-btn base-btn--small base-btn--outline-dark">
          <BaseSvg name="ico-update"/>
        </button>
        <span class="account-tab-item__label-mob">{{ $tAccount('Repeat') }}</span>
      </div>

      <div class="account-tab-item__sum">
        - {{ item.sum | formatCurrency }} <span>JBN</span>
      </div>
    </div>
  </div>
</template>

<script>
  const STATUS_RECEIVED_TO_WORK = 1
  const STATUS_IN_PROCESS = 2
  const STATUS_PAID_OUT = 3

  export default {
    props: {
      item: Object
    },
    data() {
      return {
        STATUS_RECEIVED_TO_WORK,
        STATUS_IN_PROCESS,
        STATUS_PAID_OUT,
      }
    }
  }
</script>

<style lang="less">

</style>